import dayjs, { type Dayjs } from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import { cn } from '@rocco/utils/cn';

dayjs.extend(isToday);

/**
 * The date separator for a group of chat messages.
 */
export function ChatDateSeparator({
    className,
    date,
}: {
    className?: string;
    /**
     * The date (in the client's timezone).
     */
    date: Dayjs;
}) {
    const dateString = formatMessageGroupDate(date);
    const a11yString = date.format('YYYY-MM-DD');

    return (
        <time
            className={cn(
                'block w-fit rounded-full bg-black/55 px-[12px] py-[2px] text-center text-[12px] leading-normal text-white',
                className,
            )}
            dateTime={a11yString}
            role="heading"
            aria-level={2}
        >
            {dateString}
        </time>
    );
}

/**
 * Format a Dayjs date to a readable string for message groups.
 * @param date The date to format (in the client's timezone).
 * @returns The formatted date string.
 */
function formatMessageGroupDate(date: Dayjs): string {
    if (date.isToday()) {
        return 'Today';
    }
    const today = dayjs();
    if (date.isSame(today.subtract(1, 'day'), 'day')) {
        return 'Yesterday';
    }
    const isThisYear = date.year() === new Date().getFullYear();
    return isThisYear ? date.format('D MMM') : date.format('D MMM YYYY');
}
